import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { WindowModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule, AutoCompleteModule } from '@progress/kendo-angular-dropdowns';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { PopoverModule, TooltipsModule } from '@progress/kendo-angular-tooltip';
import { DatePickerModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@angular/cdk/layout';
import { PopupModule } from '@progress/kendo-angular-popup';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { LoaderComponent } from './loader/loader.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { TabContentLoadOnDemandDirective } from './directives/lazyload.directive';
import { PersonSelectorComponent } from './search/person-selector/person-selector.component';
import { AfterFilterChangedDirective } from './directives/after-filter-changed.directive';
import { GenericSelectorModule } from './search/generic-selector/generic-selector.module';
import { GenericSearchModule } from './search/generic-search/generic-search.module';
import { GenericSelectorComponent } from './search/generic-selector/generic-selector.component';
import { GenericSearchComponent } from './search/generic-search/generic-search.component';
import { StatusHistoryComponent } from './components/status-history/status-history.component';
import { PhotoSpinnerComponent } from './components/photo-spinner/photo-spinner.component';
import { GridLegendComponent } from './grid-legend/grid-legend.component';
import { SafePipe } from './pipes/safe.pipe';
import { AttachmentsWindowComponent } from './window/attachments-window/attachments-window.component';
import { DomainDialogComponent } from '../shared/components/domain-dialog/domain-dialog.component';
import { BillingCodesDialogComponent } from "@app/cp/shared/domain-data/billing-codes-dialog/billing-codes-dialog.component";
import { PartSubcategoryDialogComponent } from "@app/cp/shared/domain-data/part-subcategory-dialog/part-subcategory-dialog.component";
import { AfterValueChangeDirectiveModule } from './directives/after-value-changed.directive.module';
import { PersonNotificationsComponent } from './components/person-notifications/person-notifications.component';
import { FilteredItemsComponent } from './components/filtered-items/filtered-items.component';
import { PotentialCustomerSelectorComponent } from './search/potential-customer-selector/potential-customer-selector.component';

import { UserCreditMemoComponent } from './components/user-credit-memo/user-credit-memo.component';
import { CPSearchModule } from './search/cp-search/cp-search.module';
import { PartTypeDialogComponent } from './domain-data/part-type-dialog/part-type-dialog.component';
import { PartCategoryDialogComponent } from './domain-data/part-category-dialog/part-category-dialog.component';
import { ManufacturerTypeDialogComponent } from './domain-data/manufacturer-type-dialog/manufacturer-type-dialog.component';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { HelpTipComponent } from './components/help-tip/help-tip.component';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

@NgModule( {
    imports: [
        CommonModule,
        LayoutModule,
        DropDownsModule,
        AutoCompleteModule,
        DateInputsModule,
        DatePickerModule,
        EditorModule,
        UploadModule,
        GridModule,
        TooltipsModule,
        WindowModule,
        PDFModule,
        ChartsModule,
        GaugesModule,
        PDFExportModule,
        ExcelModule,
        ButtonsModule,
        InputsModule,
        ExcelExportModule,
        ScrollViewModule,
        DialogsModule,
        GenericSelectorModule,
        GenericSearchModule,
        AfterValueChangeDirectiveModule,
        PopoverModule,
        PopupModule,
        CPSearchModule,
        ReactiveFormsModule,
        FormsModule
    ],
    declarations: [
        PotentialCustomerSelectorComponent,
        LoaderComponent,
        ConfirmDialogComponent,
        TabContentLoadOnDemandDirective,
        PersonSelectorComponent,
        AfterFilterChangedDirective,
        StatusHistoryComponent,
        PhotoSpinnerComponent,
        GridLegendComponent,
        SafePipe,
        AttachmentsWindowComponent,
        DomainDialogComponent,
        BillingCodesDialogComponent,
        UserCreditMemoComponent,
        PersonNotificationsComponent,
        FilteredItemsComponent,
        PartTypeDialogComponent,
        PartCategoryDialogComponent,
        PartSubcategoryDialogComponent,
        ManufacturerTypeDialogComponent,
        PageLoaderComponent,
        HelpTipComponent
    ],
    exports: [
        PotentialCustomerSelectorComponent,
        LoaderComponent,
        GenericSelectorComponent,
        GenericSearchComponent,
        ConfirmDialogComponent,
        TabContentLoadOnDemandDirective,
        AfterFilterChangedDirective,
        PersonSelectorComponent,
        StatusHistoryComponent,
        PhotoSpinnerComponent,
        GridLegendComponent,
        AttachmentsWindowComponent,
        DomainDialogComponent,
        BillingCodesDialogComponent,
        UserCreditMemoComponent,
        PersonNotificationsComponent,
        FilteredItemsComponent,
        PartTypeDialogComponent,
        PartCategoryDialogComponent,
        PartSubcategoryDialogComponent,
        ManufacturerTypeDialogComponent,
        PageLoaderComponent,
        HelpTipComponent,
        SafePipe
    ]
} )
export class SharedComponentsModule {
}
